import React from 'react';

const LineColumnChartIcon = (
  props: React.SVGProps<SVGSVGElement>
): JSX.Element => {
  return (
    <svg className="ez-svg h-full" viewBox="0 0 552 600" {...props}>
      <g className="ez-fragment-cartesian-scale">
        <g className="ez-grid" stroke="rgba(168,168,168,1)">
          <g className="ez-grid-lines">
            <path
              className="ez-grid-line"
              d="M96 40v520m43.333-520v520m43.334-520v520M226 40v520m43.333-520v520m43.334-520v520M356 40v520m43.333-520v520m43.334-520v520M486 40v520"
            />
          </g>
          <g className="ez-grid-lines">
            <path
              className="ez-grid-line"
              d="M70 560h442M70 508h442M70 456h442M70 404h442M70 352h442M70 300h442M70 248h442M70 196h442M70 144h442M70 92h442M70 40h442"
            />
          </g>
        </g>
        <g className="ez-fragment-color-scale">
          <g className="ez-bars">
            <path
              fill="#26547c"
              data-testid="ez-bar"
              className="ez-bar"
              d="M78.667 513.2h34.667V560H78.667z"
            />
            <path
              fill="#ef476f"
              data-testid="ez-bar"
              className="ez-bar"
              d="M122 326h34.667v234H122z"
            />
            <path
              fill="#ffd166"
              data-testid="ez-bar"
              className="ez-bar"
              d="M165.333 409.2H200V560h-34.667z"
            />
            <path
              fill="#06d6a0"
              data-testid="ez-bar"
              className="ez-bar"
              d="M208.667 404h34.667v156h-34.667z"
            />
            <path
              fill="#06d6d1"
              data-testid="ez-bar"
              className="ez-bar"
              d="M252 300h34.667v260H252z"
            />
            <path
              fill="#26547c"
              data-testid="ez-bar"
              className="ez-bar"
              d="M295.333 461.2H330V560h-34.667z"
            />
            <path
              fill="#ef476f"
              data-testid="ez-bar"
              className="ez-bar"
              d="M338.667 430h34.667v130h-34.667z"
            />
            <path
              fill="#ffd166"
              data-testid="ez-bar"
              className="ez-bar"
              d="M382 404h34.667v156H382z"
            />
            <path
              fill="#06d6a0"
              data-testid="ez-bar"
              className="ez-bar"
              d="M425.333 549.6H460V560h-34.667z"
            />
            <path
              fill="#06d6d1"
              data-testid="ez-bar"
              className="ez-bar"
              d="M468.667 222h34.667v338h-34.667z"
            />
          </g>
        </g>
        <g textAnchor="middle" className="ez-axis">
          <path d="M70 566v-12 6h442v6-12" className="ez-axis-path" />
          <g className="ez-axis-tick">
            <path className="ez-axis-tick-line" d="M96 560v6" />
            <text
              y="9"
              dy=".6em"
              textAnchor="end"
              transform="rotate(-20 1658.644 11.778)"
              className="ez-axis-tick-text"
            >
              Alpha
            </text>
          </g>
          <g className="ez-axis-tick">
            <path className="ez-axis-tick-line" d="M139.333 560v6" />
            <text
              y="9"
              dy=".6em"
              textAnchor="end"
              transform="rotate(-20 1680.31 -111.098)"
              className="ez-axis-tick-text"
            >
              Beta
            </text>
          </g>
          <g className="ez-axis-tick">
            <path className="ez-axis-tick-line" d="M182.667 560v6" />
            <text
              y="9"
              dy=".6em"
              textAnchor="end"
              transform="rotate(-20 1701.977 -233.978)"
              className="ez-axis-tick-text"
            >
              Gamma
            </text>
          </g>
          <g className="ez-axis-tick">
            <path className="ez-axis-tick-line" d="M226 560v6" />
            <text
              y="9"
              dy=".6em"
              textAnchor="end"
              transform="rotate(-20 1723.644 -356.855)"
              className="ez-axis-tick-text"
            >
              Delta
            </text>
          </g>
          <g className="ez-axis-tick">
            <path className="ez-axis-tick-line" d="M269.333 560v6" />
            <text
              y="9"
              dy=".6em"
              textAnchor="end"
              transform="rotate(-20 1745.31 -479.732)"
              className="ez-axis-tick-text"
            >
              Epsilon
            </text>
          </g>
          <g className="ez-axis-tick">
            <path className="ez-axis-tick-line" d="M312.667 560v6" />
            <text
              y="9"
              dy=".6em"
              textAnchor="end"
              transform="rotate(-20 1766.977 -602.611)"
              className="ez-axis-tick-text"
            >
              Zeta
            </text>
          </g>
          <g className="ez-axis-tick">
            <path className="ez-axis-tick-line" d="M356 560v6" />
            <text
              y="9"
              dy=".6em"
              textAnchor="end"
              transform="rotate(-20 1788.644 -725.488)"
              className="ez-axis-tick-text"
            >
              Eta
            </text>
          </g>
          <g className="ez-axis-tick">
            <path className="ez-axis-tick-line" d="M399.333 560v6" />
            <text
              y="9"
              dy=".6em"
              textAnchor="end"
              transform="rotate(-20 1810.31 -848.365)"
              className="ez-axis-tick-text"
            >
              Theta
            </text>
          </g>
          <g className="ez-axis-tick">
            <path className="ez-axis-tick-line" d="M442.667 560v6" />
            <text
              y="9"
              dy=".6em"
              textAnchor="end"
              transform="rotate(-20 1831.977 -971.245)"
              className="ez-axis-tick-text"
            >
              Iota
            </text>
          </g>
          <g className="ez-axis-tick">
            <path className="ez-axis-tick-line" d="M486 560v6" />
            <text
              y="9"
              dy=".6em"
              textAnchor="end"
              transform="rotate(-20 1853.644 -1094.121)"
              className="ez-axis-tick-text"
            >
              Kappa
            </text>
          </g>
        </g>
        <g textAnchor="end" className="ez-axis">
          <path d="M76 560H64h6V40h6-12" className="ez-axis-path" />
          <g className="ez-axis-tick">
            <path className="ez-axis-tick-line" d="M70 560h-6" />
            <text
              x="-9"
              dy=".3em"
              transform="translate(62 560)"
              className="ez-axis-tick-text"
            >
              0
            </text>
          </g>
          <g className="ez-axis-tick">
            <path className="ez-axis-tick-line" d="M70 508h-6" />
            <text
              x="-9"
              dy=".3em"
              transform="translate(62 508)"
              className="ez-axis-tick-text"
            >
              10
            </text>
          </g>
          <g className="ez-axis-tick">
            <path className="ez-axis-tick-line" d="M70 456h-6" />
            <text
              x="-9"
              dy=".3em"
              transform="translate(62 456)"
              className="ez-axis-tick-text"
            >
              20
            </text>
          </g>
          <g className="ez-axis-tick">
            <path className="ez-axis-tick-line" d="M70 404h-6" />
            <text
              x="-9"
              dy=".3em"
              transform="translate(62 404)"
              className="ez-axis-tick-text"
            >
              30
            </text>
          </g>
          <g className="ez-axis-tick">
            <path className="ez-axis-tick-line" d="M70 352h-6" />
            <text
              x="-9"
              dy=".3em"
              transform="translate(62 352)"
              className="ez-axis-tick-text"
            >
              40
            </text>
          </g>
          <g className="ez-axis-tick">
            <path className="ez-axis-tick-line" d="M70 300h-6" />
            <text
              x="-9"
              dy=".3em"
              transform="translate(62 300)"
              className="ez-axis-tick-text"
            >
              50
            </text>
          </g>
          <g className="ez-axis-tick">
            <path className="ez-axis-tick-line" d="M70 248h-6" />
            <text
              x="-9"
              dy=".3em"
              transform="translate(62 248)"
              className="ez-axis-tick-text"
            >
              60
            </text>
          </g>
          <g className="ez-axis-tick">
            <path className="ez-axis-tick-line" d="M70 196h-6" />
            <text
              x="-9"
              dy=".3em"
              transform="translate(62 196)"
              className="ez-axis-tick-text"
            >
              70
            </text>
          </g>
          <g className="ez-axis-tick">
            <path className="ez-axis-tick-line" d="M70 144h-6" />
            <text
              x="-9"
              dy=".3em"
              transform="translate(62 144)"
              className="ez-axis-tick-text"
            >
              80
            </text>
          </g>
          <g className="ez-axis-tick">
            <path className="ez-axis-tick-line" d="M70 92h-6" />
            <text
              x="-9"
              dy=".3em"
              transform="translate(62 92)"
              className="ez-axis-tick-text"
            >
              90
            </text>
          </g>
          <g className="ez-axis-tick">
            <path className="ez-axis-tick-line" d="M70 40h-6" />
            <text
              x="-9"
              dy=".3em"
              transform="translate(62 40)"
              className="ez-axis-tick-text"
            >
              100
            </text>
          </g>
        </g>
      </g>
      <g className="ez-fragment-cartesian-scale">
        <g className="ez-points">
          <g className="ez-line">
            <path
              d="M96 513.2 139.333 326l43.334 83.2L226 404l43.333-104 43.334 161.2L356 430l43.333-26 43.334 145.6L486 222"
              stroke="#399"
              strokeWidth="2"
              fill="none"
              strokeLinejoin="round"
              strokeLinecap="round"
              className="ez-line"
            />
          </g>
        </g>
        <g className="ez-axis">
          <path d="M506 560h12-6V40h-6 12" className="ez-axis-path" />
          <g className="ez-axis-tick">
            <path className="ez-axis-tick-line" d="M512 560h6" />
            <text
              x="9"
              dy=".3em"
              transform="translate(520 560)"
              className="ez-axis-tick-text"
            >
              0
            </text>
          </g>
          <g className="ez-axis-tick">
            <path className="ez-axis-tick-line" d="M512 508h6" />
            <text
              x="9"
              dy=".3em"
              transform="translate(520 508)"
              className="ez-axis-tick-text"
            >
              10
            </text>
          </g>
          <g className="ez-axis-tick">
            <path className="ez-axis-tick-line" d="M512 456h6" />
            <text
              x="9"
              dy=".3em"
              transform="translate(520 456)"
              className="ez-axis-tick-text"
            >
              20
            </text>
          </g>
          <g className="ez-axis-tick">
            <path className="ez-axis-tick-line" d="M512 404h6" />
            <text
              x="9"
              dy=".3em"
              transform="translate(520 404)"
              className="ez-axis-tick-text"
            >
              30
            </text>
          </g>
          <g className="ez-axis-tick">
            <path className="ez-axis-tick-line" d="M512 352h6" />
            <text
              x="9"
              dy=".3em"
              transform="translate(520 352)"
              className="ez-axis-tick-text"
            >
              40
            </text>
          </g>
          <g className="ez-axis-tick">
            <path className="ez-axis-tick-line" d="M512 300h6" />
            <text
              x="9"
              dy=".3em"
              transform="translate(520 300)"
              className="ez-axis-tick-text"
            >
              50
            </text>
          </g>
          <g className="ez-axis-tick">
            <path className="ez-axis-tick-line" d="M512 248h6" />
            <text
              x="9"
              dy=".3em"
              transform="translate(520 248)"
              className="ez-axis-tick-text"
            >
              60
            </text>
          </g>
          <g className="ez-axis-tick">
            <path className="ez-axis-tick-line" d="M512 196h6" />
            <text
              x="9"
              dy=".3em"
              transform="translate(520 196)"
              className="ez-axis-tick-text"
            >
              70
            </text>
          </g>
          <g className="ez-axis-tick">
            <path className="ez-axis-tick-line" d="M512 144h6" />
            <text
              x="9"
              dy=".3em"
              transform="translate(520 144)"
              className="ez-axis-tick-text"
            >
              80
            </text>
          </g>
          <g className="ez-axis-tick">
            <path className="ez-axis-tick-line" d="M512 92h6" />
            <text
              x="9"
              dy=".3em"
              transform="translate(520 92)"
              className="ez-axis-tick-text"
            >
              90
            </text>
          </g>
          <g className="ez-axis-tick">
            <path className="ez-axis-tick-line" d="M512 40h6" />
            <text
              x="9"
              dy=".3em"
              transform="translate(520 40)"
              className="ez-axis-tick-text"
            >
              100
            </text>
          </g>
        </g>
      </g>
    </svg>
  );
};
export default LineColumnChartIcon;
